import React, { useState, useEffect, useRef } from "react";
import AddTravelerWrapper from "./addTraveler.style";

import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { withTranslation } from "react-i18next";
import { Dialog } from "primereact/dialog";
import { classNames } from "primereact/utils";
import moment from "moment";
import * as travelService from "../../../../services/travel-service";
import * as globalUtils from "../../../../helpers/utils";
import { setLoading } from "../../../../redux/actions/travel";
import { Toast } from "primereact/toast";
import { useSelector, useDispatch } from "react-redux";
import { Captcha } from "primereact/captcha";
import { Dropdown } from "primereact/dropdown";

const AddTraveler = ({
  show = false,
  t,
  i18n,
  onPopupClose = () => false,
  onSuccess,
}) => {
  const dispatch = useDispatch();
  const toast = useRef(null);
  const [display, setDisplay] = useState(show);
  const applicants = useSelector((state) => state.travel.applicants);
  const isArabic = globalUtils.isArabic(i18n.language);
  const [isValidCaptcha, setIsValidCaptcha] = useState(true);
  const { businessLine } = useSelector((state) => state.travel);

  useEffect(() => setDisplay(show), [show]);

  const onPopupHide = () => {
    setDisplay(false);
    onPopupClose();
    formik.resetForm();
  };

  const isValidTraveller = () => {
    const { nationalId } = formik.values;
    if (nationalId === applicants.self.nationalId) {
      return false;
    }
    if (applicants.applicants && applicants.applicants.length) {
      const isExists = applicants.applicants.find(
        (ele) => ele.nationalId === nationalId
      );
      if (isExists) {
        return false;
      }
    }
    return true;
  };

  const formik = useFormik({
    initialValues: {
      nationalId: "",
      dob: "",
      month: "",
      year: "",
      Isdep: "True",
    },

    validate: (data) => {
      let errors = {};
      if (!data.nationalId) {
        errors.nationalId = t("national-id-required");
      } else if (!globalUtils.isValidSaudiIDOrIQama(data.nationalId)) {
        errors.nationalId = t("invalid-national-id");
      }
      if (!data.year) {
        errors.year = t("date-birth-required");
      }
      if (!data.month) {
        errors.month = t("date-birth-required");
      }

      return errors;
    },
    onSubmit: (data) => {
      if (!isValidTraveller()) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: t("traveller-already-exists"),
        });
        return;
      }
      // if (isValidCaptcha) {
        dispatch(setLoading(true));
        travelService
          .getPersonalData(
            {
              dobGreg: data.month + "-" + data.year,
              languageCode: globalUtils.getOneLetterLanguageCode(i18n.language),
              IDNO: data.nationalId,
              Isdep: data.Isdep,
            },
            businessLine
          )
          .then((response) => {
            dispatch(setLoading(false));
            if (response.data.resultCode === "S") {
              setDisplay(false);
              formik.resetForm();
              // window.grecaptcha.reset();
              // setIsValidCaptcha(false);
              var parts = response.data.PersonalInformation.dobGreg.split("-");
              var newDate = parts[2] + "-" + parts[1] + "-" + parts[0];
              response.data.PersonalInformation.dobGreg = newDate;
              onSuccess({
                ...response.data.PersonalInformation,
                nationalId: data.nationalId,
              });
            } else {
              // window.grecaptcha.reset();
              // setIsValidCaptcha(false);
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: response.data.resultMessage,
              });
            }
          })
          .catch((err) => {
            dispatch(setLoading(false));
            // window.grecaptcha.reset();
            // setIsValidCaptcha(false);
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Service Error",
            });
          });
      // }
    },
  });

  const startYear = 1900;
  const endYear = new Date().getFullYear();
  const years = Array.from(
    { length: endYear - startYear + 1 },
    (_, index) => startYear + index
  );
  // console.log(years,"Asdasd");

  const YearsS = years.map(String).reverse();

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <div className="p-error text-initial position-relative">
          {formik.errors[name]}
        </div>
      )
    );
  };
  return (
    <Dialog
      visible={display}
      onHide={onPopupClose}
      showHeader={false}
      closable={true}
      modal={true}
    >
      <Toast ref={toast} />
      <AddTravelerWrapper>
        <form
          onSubmit={formik.handleSubmit}
          className={"p-fluid " + (isArabic ? "ar" : "")}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <h1 className="col-md-12 titleStyle">
                  {t("add-new-traveler")}
                </h1>
                <div className="col-md-12 col-sm-12">
                  <InputText
                    id="nationalId"
                    name="nationalId"
                    value={formik.values.nationalId}
                    onChange={formik.handleChange}
                    placeholder={t("national-id")}
                    maxLength="10"
                    className={classNames({
                      "p-invalid": isFormFieldValid("nationalId"),
                      lato: formik.values.nationalId,
                    })}
                  />
                  {getFormErrorMessage("nationalId")}
                </div>
                <div className="row mt-4">
                  <div className="col-sm-12">
                    <div className="field">
                      <span className="p-float-label">
                        <Dropdown
                          name="year"
                          value={formik.values.year}
                          className={classNames({
                            "p-invalid": isFormFieldValid("year"),
                          })}
                          // placeholder={t("PERSONAL_DETAIL.YEAROFBIRTH")}
                          onChange={formik.handleChange}
                          options={YearsS}
                          // optionLabel="label"
                          // optionValue="value"
                          // filter
                          // filterBy="label"
                          // itemTemplate={numbersTemplate}
                        />
                        <label htmlFor="">{t("YEAROFBIRTH")}</label>
                      </span>
                      {/* {getFormErrorMessage("yob")} */}
                    </div>
                  </div>
                  <div className="col-sm-12 mt-4">
                    <div className="field">
                      <span className="p-float-label">
                        <Dropdown
                          name="month"
                          value={formik.values.month}
                          className={classNames({
                            "p-invalid": isFormFieldValid("month"),
                          })}
                          // // placeholder={t("PERSONAL_DETAIL.YEAROFBIRTH")}
                          onChange={formik.handleChange}
                          options={globalUtils.months}
                          // optionLabel="label"
                          // optionValue="value"
                          // filter
                          // filterBy="label"
                          // itemTemplate={numbersTemplate}
                        />
                        <label htmlFor="">{t("MONTH_BIRTH")}</label>
                      </span>
                      {/* {getFormErrorMessage("mob")} */}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-sm-12 inputField">
                  {/* <Calendar
                    className={`w-100 custom-calendar-input ${classNames({
                      "p-invalid": isFormFieldValid("dob"),
                    })}`}
                    required={true}
                    placeholder={t("DateOfBirth")}
                    dateFormat="yy-mm-dd"
                    inputClassName={`${classNames({
                      "p-invalid": isFormFieldValid("dob"),
                      lato: formik.values.dob,
                    })}`}
                    inputId="dob"
                    maxDate={new Date()}
                    value={
                      formik.values.deptDate ? new Date(formik.values.dob) : ""
                    }
                    readOnlyInput
                    showIcon
                    onChange={(data) => {
                      formik.setFieldTouched("dob", true);
                      formik.setFieldValue(
                        "dob",
                        moment(data.value).format("YYYY-MM-DD")
                      );
                    }}
                  /> */}

                  {/* <Field
                    name="dob"
                    innerName="dob"
                    component={YearDropdown}
                    inputClassName="w-100"
                    value={formik.values.dob}
                    onChange={formik.handleChange}
                  /> */}
                  {/* {getFormErrorMessage("dob")} */}
                </div>
                <div className="col-12 my-3">
                  {/* <Captcha
                    siteKey={process.env.REACT_APP_CAPTCHA_KEY}
                    onResponse={(token) => setIsValidCaptcha(true)}
                    onExpire={() => setIsValidCaptcha(false)}
                  /> */}
                </div>
                <div className="row">
                  <div className="col-sm-6 buttonDivSave">
                    <Button
                      className="buttonSave"
                      type="submit"
                      label={t("add")}
                    />
                  </div>
                  <div className="col-sm-6 buttonDiv">
                    <Button
                      type="button"
                      onClick={() => onPopupHide()}
                      className="buttonCancel"
                      label={t("cancel")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </AddTravelerWrapper>
    </Dialog>
  );
};

export default withTranslation()(AddTraveler);
